module.exports = __webpack_public_path__ + "static/media/after_translate.1bb8f3fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/NDF/Implementation/img/after_translate.png
// module id = 180
// module chunks = 0